import { NavigateFunction } from "react-router";

class NavigationService {
  private navigate: NavigateFunction | null = null;

  setNavigate(navigate: NavigateFunction) {
    this.navigate = navigate;
  }

  push(path: string) {
    if (this.navigate) {
      this.navigate(path);
    }
  }

  goBack() {
    if (this.navigate) {
      this.navigate(-1);
    }
  }
}

export const navigationService = new NavigationService(); 
